/* eslint-disable @typescript-eslint/no-explicit-any,no-console */

import { aegis } from './aegis';

const logger = {
  info(...msg: any[]): void {
    if (process.env.NODE_ENV === 'development' || window.VConsole) {
      console.log(...msg);
    }
    aegis.info(msg);
  },
  warn(...msg: any[]): void {
    if (process.env.NODE_ENV === 'development' || window.VConsole) {
      console.warn(...msg);
    }
    aegis.infoAll(msg);
  },
  error(...msg: any[]): void {
    if (process.env.NODE_ENV === 'development' || window.VConsole) {
      console.error(...msg);
    }
    aegis.error(msg);
  },
  imError(...msg: any[]): void {
    if (process.env.NODE_ENV === 'development' || window.VConsole) {
      console.error('IM-Error', ...msg);
    }
    aegis.reportEvent({
      name: 'imError',
      ext1: msg.join(','),
    });
  },
};

export { logger };
